var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.$t("settings.role.roleEdit")))]),
    _c(
      "div",
      { staticClass: "mt-3 elevation-12 grey lighten-4" },
      [
        _c(
          "v-card",
          [
            _c(
              "v-card-text",
              [
                _c(
                  "v-form",
                  {
                    ref: "form",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.formValid,
                      callback: function($$v) {
                        _vm.formValid = $$v
                      },
                      expression: "formValid"
                    }
                  },
                  [
                    _c("v-text-field", {
                      attrs: {
                        disabled: typeof this.$route.params.id !== "undefined",
                        rules: _vm.role.nameRules,
                        label: _vm.$t("settings.role.fields.name.name") + "*"
                      },
                      model: {
                        value: _vm.role.name,
                        callback: function($$v) {
                          _vm.$set(_vm.role, "name", $$v)
                        },
                        expression: "role.name"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t("settings.role.fields.description.name")
                      },
                      model: {
                        value: _vm.role.description,
                        callback: function($$v) {
                          _vm.$set(_vm.role, "description", $$v)
                        },
                        expression: "role.description"
                      }
                    }),
                    _c(
                      "v-data-table",
                      {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.hasAuthItems,
                          "hide-default-footer": "",
                          "footer-props": {
                            "items-per-page-options": [
                              {
                                text: "$vuetify.dataIterator.rowsPerPageAll",
                                value: -1
                              }
                            ]
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function(props) {
                              return [
                                _c("tr", [
                                  _c("td", { staticClass: "text-left" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          props.item.type == 2
                                            ? _vm.$t("global.permission")
                                            : _vm.$t("global.role")
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c("td", { staticClass: "text-left" }, [
                                    _vm._v(_vm._s(props.item.translated_name))
                                  ]),
                                  _c("td", { staticClass: "text-left" }, [
                                    _vm._v(_vm._s(props.item.description))
                                  ]),
                                  _c(
                                    "td",
                                    { staticClass: "text-left" },
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          attrs: { icon: "" },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeAuthItem(
                                                                props.item.name
                                                              )
                                                            }
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v("clear")
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("global.delete")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      },
                      [
                        _c(
                          "template",
                          { slot: "no-data" },
                          [
                            _c(
                              "v-alert",
                              { attrs: { color: "error", icon: "warning" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("settings.role.noPermissions")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      2
                    ),
                    _c(
                      "v-row",
                      { staticClass: "mt-5 md-2" },
                      [
                        _c("v-col", [
                          _c("h4", [
                            _vm._v(
                              _vm._s(_vm.$t("settings.role.addPermissions"))
                            )
                          ])
                        ]),
                        _c("v-spacer"),
                        _c(
                          "v-col",
                          { attrs: { cols: "3" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: _vm.$t("global.search"),
                                "append-icon": "search",
                                "hide-details": "",
                                "single-line": ""
                              },
                              model: {
                                value: _vm.search,
                                callback: function($$v) {
                                  _vm.search = $$v
                                },
                                expression: "search"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("v-data-table", {
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.availableAuthItems,
                        search: _vm.search
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "item",
                          fn: function(props) {
                            return [
                              _c("tr", [
                                _c("td", { staticClass: "text-left" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        props.item.type == 2
                                          ? _vm.$t("global.permission")
                                          : _vm.$t("global.role")
                                      ) +
                                      " "
                                  )
                                ]),
                                _c("td", { staticClass: "text-left" }, [
                                  _vm._v(_vm._s(props.item.translated_name))
                                ]),
                                _c("td", { staticClass: "text-left" }, [
                                  _vm._v(_vm._s(props.item.description))
                                ]),
                                _c(
                                  "td",
                                  { staticClass: "text-left" },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    _vm._g(
                                                      {
                                                        attrs: { icon: "" },
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.addAuthItem(
                                                              props.item.name
                                                            )
                                                          }
                                                        }
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("add")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("global.add")) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-card",
          [
            _c(
              "v-card-actions",
              [
                _c("v-spacer"),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "blue darken-1", text: "" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      disabled: !_vm.formValid,
                      color: "blue darken-1",
                      text: ""
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.save")) + " ")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }